import { User_Attachment } from "../../models/RestModels";

export function getEmptyUserAttachment(): User_Attachment
{
		return {
			alias: '',
			created: new Date(),
			created_by_user_id: 0,
			id: 0,
			updated: new Date(),
			updated_by_user_id: 0,
			user_id: 0,
			attachment_id: 0,
			status: 'ACTIVE',
		};
}
